import { createFileRoute } from '@tanstack/react-router';
import { ClientTaxBinderDetailPage } from '@/features/tax-binders/ClientTaxBinderDetailPage';

export const Route = createFileRoute('/tax-binders/$binderId/')({
  component: () => <ClientTaxBinderDetailPage />,
});
